<script setup>
import { computed } from 'vue';
import Commons from '../../shared/libraries/commons';

const props = defineProps({
  match: {
    required: true,
    type: Object
  }
});

const probableWinner = computed(() => {
  let winner = {
    ...props.match?.team1,
    ...props.match.allOdds?.['1'],
    title: `${props.match?.team1?.name} Gagne`,
    type: 'home'
  };
  if (winner?.probability < props.match.allOdds?.['2']?.probability) {
    winner = {
      ...props.match?.team2,
      ...props.match.allOdds?.['2'],
      title: `${props.match?.team2?.name} Gagne`,
      type: 'away'
    };
  }
  if (winner?.probability < props.match.allOdds?.[3]?.probability) {
    winner = {
      ...props.match.allOdds?.['3'],
      title: 'Match nul',
      type: 'draw'
    };
  }

  return winner;
});
</script>

<template>
  <div class="bg-slate-50 rounded-3xl h-full flex flex-col">
    <!-- date badge -->
    <div class="px-4 pt-4">
      <div class="inline-block px-3 py-1 text-xs font-semibold text-primary bg-primary/10 rounded-full">
        {{ Commons.time(match?.date, 'dddd D MMM') }}
      </div>
    </div>

    <!-- teams -->
    <div class="flex items-center justify-between gap-3 px-4 pt-6 pb-1 flex-1">
      <div class="flex flex-col items-center gap-2 flex-1">
        <div class="w-20 h-20 p-1.5 bg-white rounded-2xl">
          <ImgComponent :src="match?.team1?.logo" fallback="/images/match/t-shirt.svg" class="w-full h-full" alt="" />
        </div>
        <div class="text-sm font-semibold text-center text-slate-700 line-clamp-2">
          {{ match?.team1?.name ?? '' }}
        </div>
      </div>

      <div class="text-lg font-black text-primary/30 px-2">vs</div>

      <div class="flex flex-col items-center gap-2 flex-1">
        <div class="w-20 h-20 p-1.5 bg-white rounded-2xl">
          <ImgComponent :src="match?.team2?.logo" fallback="/images/match/t-shirt.svg" class="w-full h-full" alt="" />
        </div>
        <div class="text-sm font-semibold text-center text-slate-700 line-clamp-2">
          {{ match?.team2?.name ?? '' }}
        </div>
      </div>
    </div>

    <!-- prediction card -->
    <div
      class="mx-3 mb-3 p-4 bg-secondary-600 rounded-2xl cursor-pointer"
      @click.stop="$bus.emit($constants.EVENTS.SERVICES.START, { group: 'recharges', option: 'fund' })"
    >
      <div class="flex items-center justify-between gap-3">
        <div class="flex-1">
          <div class="text-sm text-white/80 font-medium mb-1">Clique pour déposer</div>
          <div class="text-base font-bold text-white leading-tight">{{ probableWinner.title }}</div>
        </div>
        <div class="flex flex-col items-end">
          <div class="text-3xl font-black text-white">{{ probableWinner.probability }}</div>
          <div class="text-xs text-white/70">probabilité</div>
        </div>
      </div>
    </div>
  </div>
</template>
